import dayjs from 'dayjs';
import { useFormContext, useWatch } from 'react-hook-form';
import { CreateVisitType } from '../../../../entity';
import { useVisitsQuery } from '../../../../queries';
import { normalizeDate } from '../../../../schedule/store';
import { useServicesQuery } from '@features/service/queries';
import { getServiceDurationMinutes } from '@features/service/entity';

export const useReservationManualDate = () => {
  const { control, setValue } = useFormContext<CreateVisitType>();
  const selectedDate = useWatch({ control, name: 'date' });
  const dateTo = useWatch({ control, name: 'dateTo' });
  const serviceIds = useWatch({ control, name: 'serviceIds' });
  const showManualDatePickers = useWatch({ control, name: 'manualDateTimeOverride' }) ?? false;
  const visitsOnSelectedDate = useGetVisitsByDate(selectedDate);

  const { data: services } = useServicesQuery();
  const selectedService = services?.find(s => s.id === serviceIds);
  const serviceDurationMinutes = selectedService
    ? getServiceDurationMinutes(selectedService)
    : null;

  const isDurationModified =
    showManualDatePickers &&
    selectedDate != null &&
    dateTo != null &&
    serviceDurationMinutes !== null &&
    dayjs(dateTo).diff(dayjs(selectedDate), 'minute') !== serviceDurationMinutes;

  const handleToggle = () => setValue('manualDateTimeOverride', !showManualDatePickers);

  return {
    visitsOnSelectedDate,
    showManualDatePickers,
    isDurationModified,
    serviceDurationMinutes,
    handleToggle,
  };
};

export const useGetVisitsByDate = (date: Date | undefined) => {
  const selectedDay = date ? dayjs(date) : dayjs();
  const { data: visitsForMonth } = useVisitsQuery({
    query: {
      from: selectedDay.startOf('month'),
      to: selectedDay.endOf('month'),
    },
  });

  return visitsForMonth
    ? visitsForMonth.filter(v => normalizeDate(v.visit.dateFrom) === normalizeDate(selectedDay))
    : [];
};
